module.exports = __webpack_public_path__ + "static/media/car.bb4173f5.jpg";